import React, { Component } from "react";
import Footer from "./Footerpersonalizado";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import WhatsAppButton from "./WhatsappButton";
import { Helmet } from "react-helmet";
import StaticPageStatus from "../SharedViews/StaticPageStatus";
import NavbarV2 from "./NavbarV2";
import Carruselv2 from "./Carruselv2";
import CardCarousel from "./CardCarousel";
import Benefits from "./Benefits";
import FAQHome from "./FAQHome";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Footerv2 from "./Footerv2";
import { setNavbarItems } from "../../globalState/app";
import { setNavbar } from "../Actions/Home_Actions";

class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      front_modules: this.props.front_modules || [],
      sectionsList: [],
      contents: [],
      contents_length: 0,
      creditos: [],
      aliados: [],
      landing: [],
      footer: [],
      hereYouCan: []
    };

  }


  componentDidMount = () => {
    this.setState({ loading: true });
    this.getHereYoCan()
  };

  getHereYoCan = () => {
    let url = settings.backend.hereYouCan;
    fetch(url, {
      method: "GET",
    }).then(FetchResponses.processResponse)
      .then((response) => {
        
        this.setState({
          hereYouCan: response
        });
      }).catch(this.failureDataResponse);
  }

  updateContentState = () => {
    this.setState({ loading: true });
    let url = settings.backend.listContent;
    fetch(url, {
      method: "GET",
      headers: settings.headers_super_auth,
    }).then(FetchResponses.processResponse)
      .then((response) => {
        this.setState({
          contents: response.contents,
          contents_length: response.contents_length,
          loading: false,
        });
      })
      .catch(this.failureDataResponse);
  };

  componentDidUpdate(prevProps, prevState) {
    // Asegúrate de que front_modules esté disponible en props antes de intentar acceder a él
    if (prevProps.front_modules && this.props.front_modules && prevProps.front_modules !== this.props.front_modules) {
       this.setState({
        front_modules: this.props.front_modules
       })
    }
  }

  render() {
    const { hereYouCan } = this.state
    return (
      <StaticPageStatus>
        <Helmet>
          <title>Crédito 20 minutos | Solicitar crédito en línea con cedula </title>
          <meta name="description" content="Crédito 20 minutos: Alkomprar, Alkosto, Ktronix, Kalley, AKT [crédito en minutos]. Ingresa ahora y solicita créditos rápidos y fáciles. Pagos crédito 20 min" />
        </Helmet>
        <WhatsAppButton />
        <div className="body-container">
          <div className="hero-section11">
            <div className="container">
              <div className="row"></div>
            </div>
            <Carruselv2 front_modules={this.state.front_modules}/>
          </div>
          <main>
            <div>
              <CardCarousel initialCards={this.state.hereYouCan}  />
              <Benefits />
              <FAQHome front_modules={this.state.front_modules}/>
            </div>
          </main>
        </div>
      </StaticPageStatus>
    );
  }
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, { setNavbar })(withRouter(MainPage))
